<template>
    <lb-drawer data-testid="transaction-matching-config-new__add-reconciliation-drawer" :value="dialog" @input="$emit('update:dialog', $event)" heading="Add New Reconciliation" width="600" :loading="loading">
        <template v-slot:body>
            <div>
                <v-row>
                    <v-col cols="12" class="my-0 py-0">
                        <lb-string data-testid="transaction-matching-config-new__reconciliation-description-input" :value="recoincilationItem.description" @input="updateItem('description', $event)" label="Description*" :error="recoincilationErrorItem.description" />
                    </v-col>
                    <v-col cols="12" class="my-0 py-0">
                        <lb-number data-testid="transaction-matching-config-new__reconciliation-subamount-input" :value="recoincilationItem.subamount" @input="updateItem('subamount', $event)" label="Sub Amount*" :error="recoincilationErrorItem.subamount" />
                    </v-col>
                </v-row>
            </div>
        </template>
        <template v-slot:actions>
            <v-spacer></v-spacer>
            <v-btn data-testid="transaction-matching-config-new__add-reconciliation-button" color="primary" class="" @click="$emit('add')">
                <span>Add</span>
            </v-btn>
        </template>
    </lb-drawer>
</template>

<script>
export default {
    name: 'ReconciliationDrawer',
    props: {
        dialog: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        },
        recoincilationItem: {
            type: Object,
            default: () => ({ description: '', subamount: '' })
        },
        recoincilationErrorItem: {
            type: Object,
            default: () => ({ description: '', subamount: '' })
        }
    },
    methods: {
        updateItem(field, value) {
            // Emitting individual field updates or the whole object depending on parent preference.
            // Here assuming we modify the object prop directly isn't ideal in Vue, but if it's a reactive object from parent it might work.
            // Better to emit an update event.
            const newItem = { ...this.recoincilationItem, [field]: value };
            this.$emit('update:recoincilationItem', newItem);
        }
    }
}
</script>